import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";
import { AssistancesExecutionsWithDifferentStartEndDateDTO } from "../models/Kpi/AssistancesExecutionsWithDifferentStartEndDateDTO";
import { AssistancesExecutionsWithTotalTimeOver7HoursDTO } from "../models/Kpi/AssistancesExecutionsWithTotalTimeOver7HoursDTO";
import { BrandModelDTO } from "../models/Kpi/BrandModelDTO";
import { AssistancesWithExecutionNotFinishedDTO } from "../models/Kpi/AssistancesWithExecutionNotFinishedDTO";
import { TechnicianHoursPastDayDTO } from "../models/Kpi/TechnicianHoursPastDayDTO";
import { CurrentAndLastMonthAssistancesDTO } from "../models/Kpi/CurrentAndLastMonthAssistancesDTO";
import { CurrentAndLastWeekAssistancesPerTechnicianDTO } from "../models/Kpi/CurrentAndLastWeekAssistancesPerTechnicianDTO";
import { OpenAssistancesMoreThan10DaysDTO } from "../models/Kpi/OpenAssistancesMoreThan10DaysDTO";
import { KpiDashboardMetricsDTO } from "../models/Kpi/KpiDashboardMetricsDTO";
import { KpiClientsDashboardDTO } from "../models/Kpi/KpiClientsDashboardDTO";
import { KpiClientAssistancesHistoryDashboardResponseDTO } from "../models/Kpi/KpiClientAssistancesHistoryDashboardResponseDTO";

export class KpiService {
    async GetAssistancesExecutionsWithDifferentStartEndDate(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<AssistancesExecutionsWithDifferentStartEndDateDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Kpis/AssistancesExecutionsWithDifferentStartEndDate`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<AssistancesExecutionsWithDifferentStartEndDateDTO>(
                false,
                "Erro ao ligar ao servidor para obter as execuções de assistências com datas de início e fim diferentes",
                "",
                [],
                0,
            );
        }
    }
    async GetAssistancesExecutionsWithTotalTimeOver7Hours(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<AssistancesExecutionsWithTotalTimeOver7HoursDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Kpis/AssistancesExecutionsWithTotalTimeOver7Hours`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<AssistancesExecutionsWithTotalTimeOver7HoursDTO>(
                false,
                "Erro ao ligar ao servidor para obter as execuções de assistências com tempo total superior a 7 horas",
                "",
                [],
                0,
            );
        }
    }

    async GetByBrandModel(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<BrandModelDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Kpis/BrandModel`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<BrandModelDTO>(
                false,
                "Erro ao ligar ao servidor para obter os equipamentos por marca e modelo",
                "",
                [],
                0,
            );
        }
    }

    async GetAssistancesWithExecutionNotFinished(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<AssistancesWithExecutionNotFinishedDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Kpis/AssistancesWithExecutionNotFinished`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<AssistancesWithExecutionNotFinishedDTO>(
                false,
                "Erro ao ligar ao servidor para obter as assistências com execuções não finalizadas",
                "",
                [],
                0,
            );
        }
    }

    async GetOpenAssistancesMoreThan10DaysDTO(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<OpenAssistancesMoreThan10DaysDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Kpis/OpenAssistancesMoreThan10Days`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<OpenAssistancesMoreThan10DaysDTO>(
                false,
                "Erro ao ligar ao servidor para obter assistências por fechar com mais de 10 dias.",
                "",
                [],
                0,
            );
        }
    }

    async GetCurrentAndLastMonthAssistances(): Promise<MessagingHelper<CurrentAndLastMonthAssistancesDTO>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Kpis/CurrentAndLastMonthAssistances`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<CurrentAndLastMonthAssistancesDTO>(
                false,
                "Erro ao ligar ao servidor para obter as assistências para o mês atual e anterior",
                {
                    currentMonthAssistances: 0,
                    lastMonthAssistances: 0,
                }
            );
        }
    }

    async GetTechnicianHoursPastDay(): Promise<MessagingHelper<TechnicianHoursPastDayDTO[]>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Kpis/TechnicianHoursPastDay`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<TechnicianHoursPastDayDTO[]>(
                false,
                "Erro ao ligar ao servidor para obter as horas de trabalho dos técnicos do dia anterior",
                []
            );
        }
    }

    async GetCurrentAndLastWeekRegisteredTimesPerTechnician(): Promise<MessagingHelper<CurrentAndLastWeekAssistancesPerTechnicianDTO | null>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Kpis/CurrentAndLastWeekRegisteredTimesPerTechnician`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<CurrentAndLastWeekAssistancesPerTechnicianDTO | null>(
                false,
                "Erro ao ligar ao servidor para obter os tempos registados da semana atual e anterior, por técnico",
                null
            );
        }
    }

    async GetCurrentAndLastWeekDebtTimesPerTechnician(): Promise<MessagingHelper<CurrentAndLastWeekAssistancesPerTechnicianDTO | null>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Kpis/CurrentAndLastWeekDebtTimesPerTechnician`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<CurrentAndLastWeekAssistancesPerTechnicianDTO | null>(
                false,
                "Erro ao ligar ao servidor para obter os tempos debitados da semana atual e anterior, por técnico",
                null
            );
        }
    }

    async GetKpiDashboardMetrics(technicianCode: string | undefined): Promise<MessagingHelper<KpiDashboardMetricsDTO | null>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Kpis/KpiDashboardMetrics?technicianCodeFilter=${technicianCode}`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<KpiDashboardMetricsDTO | null>(
                false,
                "Erro ao ligar ao servidor para obter os dados dos painéis de métricas",
                null
            );
        }
    }

    async GetClientsDashboardData(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
        topCount: number = 6, //mudar consoante número de barras (clientes com mais assistências) que queremos no gráfico
    ): Promise<MessagingHelper<KpiClientsDashboardDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Kpis/ClientsDashboard?topCount=${topCount}`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return new MessagingHelper<KpiClientsDashboardDTO>(
                false,
                "Erro ao carregar os dados do dashboard dos clientes",
                {
                    topClients: [],
                    clientsData: {
                        success: false,
                        message: "",
                        name: "",
                        items: [],
                        totalPages: 0,
                        totalRecords: 0,
                        pageSize: 0,
                        count: 0
                    },
                }
            );
        }
    }

        
    async KpiClientAssistancesHistoryDashboard(clientErpId: string): Promise<MessagingHelper<KpiClientAssistancesHistoryDashboardResponseDTO[] | null>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/Kpis/KpiClientAssistancesHistoryDashboard?clientErpId=${clientErpId}`,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<KpiClientAssistancesHistoryDashboardResponseDTO[] | null>(
                false,
                "Erro ao ligar ao servidor para obter dados do dashboard de histórico de assistências do cliente",
                null
            );
        }
    }
}